<template>
  <el-dialog
    :visible.sync="display"
    width="30%"
    :modal-append-to-body="false"
    center
  >
    <div class="logo">
      <img class="image" :src="imagePath" />
    </div>

    <div class="request-title">
      {{ $t('Integrations_Text_IntegrationRequested') }}
    </div>

    <p class="request-description">
      {{ $t('Integrations_Text_IntegrationRequested_Description') }}
    </p>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="display = false">
        {{ $t('Integrations_Button_Okay') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'IntegrationRequestedPopup',

  props: {
    integration: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      display: false
    }
  },

  computed: {
    imagePath() {
      return this.integration.image
    }
  },

  methods: {
    show() {
      this.display = true
    }
  }
}
</script>

<style scoped>
.logo {
  margin: auto;
  height: 160px;
  width: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image {
  max-width: 90%;
  max-height: 100%;
}

.request-title {
  color: #333333;
  font-weight: 600;
  font-size: 24px;
  text-align: center;
  line-height: 30px;
}

.request-description {
  font-size: 13px;
  line-height: 24px;
  text-align: center;
  color: #808080;
  margin-top: 16px;
}
</style>



// WEBPACK FOOTER //
// src/modules/integrations/components/IntegrationRequestedPopup.vue